import React, { useState } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Selectoption from "../../components/formikcomponent/SelectFieldWithLabel";
import File from '../../components/formikcomponent/Imageinput';
import formikVideo from '../../articlecontent/VideoFile';
import {string, number, mixed, array, object} from 'yup';
import Constants from '../../components/Fields/DropDownList';
import DiseaseSegment from'../../components/Fields/DiseaseSegment';
import ErrorDialog from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import { Typography, makeStyles, Button,  Grid, Paper,withStyles } from '@material-ui/core';
import { Formik, Field, Form,} from "formik";
import { v4 as uuidv4 } from "uuid";
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import Resourceid  from '../../components/Fields/Resource';
import Audiofield from '../../components/Fields/AudioFields';
import Persona from'../../components/Fields/Persona';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StatusCodes} from 'http-status-codes';
import Category from '../../components/Fields/Category';
import Fieldtext from '../../components/Fields/FieldText';
const Meditationform = (props) => {
const [open, setOpen] =  useState(false);
 const [openpopup, setOpenpopup] = useState(false);
 const [sucessCurr, setSucessCurr] = useState(false);
 const [load, setLoad] = useState(false);
const[errorCurr,setErrorCurr]=useState(false);
const[disablemedsubmit,setDisablemedSubmit]= useState(false);
const [UpdatedMessage, setUpdatedMessage] = useState("");
const [ImageErrorclosemed, setImageErrorClosemed] = React.useState(false);
 const [meditationdata, setMeditationdata] = useState({
 content: {
                image: "",
                details: [
                    {
                        url:"",
                        type: 1,
                        duration: ""
                    },
                    {
                        url:"",
                        type: 2,
                        duration: ""
                    },
                    {
                        url: "",
                        type: 3,
                        duration: ""
                    }

                ]
            },
            title: '',
            category: [],
            topicid: [],
            diseasesegment: [],
            persona: [],
            resourceid:"",
            isdeleted:0,
            type:6});
let selectOptions = [{value: 1,label: "Body Relaxation"},{value: 2,label: "Using the Breath to Calm"}];
let selectTopic = [{value: 57,label: "10:03 duration"},{value:56,label: "05:03 duration"}];
let personaMedValue=Constants.personaValue;
let diseaseSegmentmedValue=Constants.diseaseSegmentValue;

  const ERR_MESSAGE = "This field is required.";
  let validateWithSchema = object().shape({
    content: object().shape({
      image: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
      details: array().of(object().shape({
        url: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE).test("file", "File Size is greater than 25MB/Unsupported Format", value => value && !(value.includes("fakepath"))),
        type: number().required(ERR_MESSAGE),
        duration: string().matches(/^([0-5]?\d):([0-5]?\d)$/,'The field accept only duration of time (00:00)').required(ERR_MESSAGE),
      })),
    }),
    title: string().required(ERR_MESSAGE),
    category: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    topicid: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    diseasesegment: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    persona: mixed().when("isArray", { is: Array.isArray, then: array().of(string()), otherwise: string().typeError(ERR_MESSAGE), }).required(ERR_MESSAGE),
    resourceid: string().required(ERR_MESSAGE),
  });

const useStyles = makeStyles(theme => ({
  heading: { maxWidth:'1100px', margin:'auto', marginTop:'20px', fontSize: "40px", textAlign: "left", textDecoration: "none", color:'rgb(6, 48, 63)' },
  para: { padding: "15px", paddingLeft: "50px" },
  image: { marginBottom: "5px" },
  holder:{backgroundColor:'white', paddingTop:'30px'},
  main:{ maxWidth:'1100px', margin:'auto'},
  paddingBottom: { paddingBottom: "30px" },
audiopadding:{ paddingBottom: "35px",paddingTop:"35px"},
  inputItem: { width: "100%" },
  createUserSelect: { '& p': { maxWidth: "200px",textOverflow: "ellipsis",display: "inline-block",overflow: "hidden",whiteSpace: "nowrap !important"} },
  para1: { float: "right", paddingRight: "20px" },
  createUser: {width:"230px", color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
  borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main,
 color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` } },
  successDialogOK: {color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
  borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 15px", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor,
  border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` }},
  errormessage:{color:"#f44336",fontSize:" 0.75rem",paddingTop:"3px"},
  cancelBtn: { width: "242px", height: "36px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)", color: "rgba(75, 123, 227, 1)", borderRadius: "25px",
  border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
  '&:hover': { color: '#1d5d90',  border: "1px solid " },
  [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft:0
  }},
  gridHeader: { paddingLeft: "5px", paddingBottom: "25px", paddingTop: "5px" },
  clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "17px" },
  button: { height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", color: "white", paddingTop: "7px", width:'100%',
 paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer", borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" },
 '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'} },
}));
 const classes = useStyles();
const handleCloseDialogMed = () => {
      setOpen(false);
      setSucessCurr(false);
      props.history.push("/Home/Meditation");
  };
 const handleErrorUserMed = () => {
    setOpen(false);
    setErrorCurr(false);
    setImageErrorClosemed(false);
  };
const sendsucessMed = () => {
    setOpen(true);
    setSucessCurr(true);
  };
  const senderrorMed = () => {
    setOpen(true);
    setErrorCurr(true);
  };
  const imageerror=()=>{
  setOpen(true);
setImageErrorClosemed(true);
};
const imageerrormessage="Image/Audio are not saved, Please submit again";
 let InactivateTriviaButton = [<Button className={classes.successDialogOK} onClick={handleCloseDialogMed}>{"OK"}</Button>];
let InactivateTriviaButton1 = [<Button className={classes.successDialogOK} onClick={handleErrorUserMed}>{"OK"}</Button>];
  let  SuccessMessage = "Meditation Content has been created successfully.";
  let errorMessage1 = "Please check Content ID already exit.";
  let two=2;
React.useEffect(()=>{
  setUpdatedMessage("Meditation Content has been Updated successfully.");
  if(props.location.clone === "clone"){
    setUpdatedMessage(SuccessMessage);
  }
const Updatedata=(value,label,name)=>{
  let comingvalue = [];
        if(name===1){
         label.find((val) => {
          if (val.value === value) {
            comingvalue.push({value:val.value,label:val.label});
          }
        });
        }
     if(name===two){
         label.find((val) => {
          if (val.value === value[0]) {
            comingvalue.push({value:val.value,label:val.label});
          }
        });
        } else{
       if (value) {
         for (let i = 0; i < value.length; i++) {
           label.find((val) => {
             if (val.label === value[i]) {
               let topic = { value: val.value, label: val.label };
               comingvalue.push(topic);
             }
           });
         }
       }
      }
return comingvalue ;
};
  if (props.location.state) {
    setOpenpopup(true);
    meditationdata.category = Updatedata(props.location.state.detail[0].category, selectOptions, 1);
    meditationdata.category = meditationdata.category[0];
    meditationdata.topicid = Updatedata(props.location.state.detail[0].topicid, selectTopic, two);
    meditationdata.topicid = meditationdata.topicid[0];
    if(props.location.clone !== "clone"){
      meditationdata.resourceid = props.location.state.detail[0].resourceid;
    }
    meditationdata.diseasesegment = Updatedata(props.location.state.detail[0].diseasesegment, diseaseSegmentmedValue);
    meditationdata.persona = Updatedata(props.location.state.detail[0].persona, personaMedValue);
    if(props.location.newversion_clone){
    meditationdata.veevacontentid = (props.location.state.detail[0].veevacontentid);}
    meditationdata.title = props.location.state.detail[0].title;
    if(props.location.state.detail[0].versionNumber!==props.location.state.detail[0].Version.newversion&&props.location.clone !== "clone"){
setDisablemedSubmit(true);
}
    if (meditationdata.content && props.location.state.detail[0].content) {
      meditationdata.content.image = props.location.state.detail[0].content.image;
      meditationdata.content.details[0].url = props.location.state.detail[0].content.details[0].url;
      meditationdata.content.details[1].url = props.location.state.detail[0].content.details[1].url;
      meditationdata.content.details[two].url = props.location.state.detail[0].content.details[two].url;
      meditationdata.content.details[0].duration = props.location.state.detail[0].content.details[0].duration;
      meditationdata.content.details[1].duration = props.location.state.detail[0].content.details[1].duration;
      meditationdata.content.details[two].duration = props.location.state.detail[0].content.details[two].duration;
    }
  }
setMeditationdata(meditationdata) ;
},[]);
const handleDisable = () => {
  if(props.location.clone === "clone"){
    return false;
  }
  if(props.location.state){
    return true;
  }
  return false;
};
  return(
    <>
     <Typography className={classes.heading} component="h5">Meditation Form</Typography>
     <Formik
        enableReinitialize={true}
        validator={() => ({})}
        validationSchema={validateWithSchema}
        initialValues={meditationdata}
        onSubmit={(values) => {
          setLoad(true);
          let sendingvalue = ({ ...values, content: { ...values.content } });
          const GetInsertvalue = (value) => {
            let trigger = [];
            value.map((obj) => {
              trigger.push(String(obj.label));
            });
            return trigger;
          };
          sendingvalue.diseasesegment = GetInsertvalue(values.diseasesegment);
          sendingvalue.persona = GetInsertvalue(values.persona);
          if (typeof (values.category) === "object") {
            sendingvalue.category = values.category.value;
          }
          if (typeof (values.topicid) === "object") {
            let topic = [];
            topic.push(values.topicid.value);
            sendingvalue.topicid = topic;
          }
          if (typeof (values.title) === "string") {
            let trigger = [];
            trigger.push(values.title);
            sendingvalue.title = trigger;
          }
          async function sendMeditation() {
            let url = "";
            url = "/api/content/contentservice/saveMeditationResource";
            if(props.history.location.pathname.includes("revision") && props.location.clone !== "clone"){
              url = "/api/content/contentservice/createRevisionForMeditationResource";
            }
            if(props.history.location.pathname.includes("version") && props.location.clone !== "clone"){
              url = "/api/content/contentservice/createVersionForMeditationResource";
            }
            let medresponse = await props.authenticatedApiCall("post", url, sendingvalue);
            setLoad(false);
            if (medresponse && medresponse.status === StatusCodes.OK) {
              sendsucessMed();
            }
            if (medresponse && medresponse.status === StatusCodes.BAD_REQUEST) {
              senderrorMed();
            }
          }
          if(props.location.state){
            sendingvalue.id = props.location.state.detail[0].id;
          }
          if (typeof (values.content.details[1].url) !== "string" || typeof (values.content.details[0].url) !== "string" || typeof (values.content.details[two].url) !== "string" || values.content.image.base64Rep) {
            let resdata = [];
            let MEDITATION_TEXT = "Meditation&";
            async function sendMusic() {
              let data = new FormData();
              for (let i = 0; i < 4; i++) {
                if (values.content.image !== "" && i === 0 && values.content.image.base64Rep) {
                  data.append(`imagefile`, values.content.image, MEDITATION_TEXT + values.resourceid + "_image_" + uuidv4() + ".jpg");
                }
                if (values.content.details[0].url !== "" && i === 1 && typeof (values.content.details[0].url) !== "string") {
                  data.append(`imagefile`, values.content.details[0].url[0], `${MEDITATION_TEXT + values.resourceid + "_Music1_" + uuidv4() + ".MP3"}`);
                }
                if (values.content.details[1].url !== "" && i === two && typeof (values.content.details[1].url) !== "string") {
                  data.append(`imagefile`, values.content.details[1].url[0], `${MEDITATION_TEXT + values.resourceid + "_voice1_" + uuidv4() + ".MP3"}`);
                }
                if (values.content.details[two].url !== "" && i === 3 && typeof (values.content.details[two].url) !== "string") {
                  data.append(`imagefile`, values.content.details[two].url[0], `${MEDITATION_TEXT + values.resourceid + "_Music_voice2_" + uuidv4() + ".MP3"}`);
                }
              }
              let url = "/api/content/contentservice/contentToolFileUpload";
              let response = await props.authenticatedApiCall("post", url, data);
              if (response && response.status === StatusCodes.OK) {
                if (response.data.result) {
                  response.data.result.map((res) => {
                    return resdata.push(props.currentUser.config.s3BucketBaseUrl + res.Key);
                  });
              if(values.content.image.base64Rep){
                  sendingvalue.content.image = resdata[0];}
              resdata.map((value,index)=>{
                  if(value.includes("Music1")){
                  sendingvalue.content.details[0].url = resdata[index];
              }  if(value.includes("voice1")){
                  sendingvalue.content.details[1].url = resdata[index];
              }  if(value.includes("voice2")){
                  sendingvalue.content.details[two].url = resdata[index];
              }
              })
                  // sendingvalue.content.details[0].url = resdata[1];
                  // sendingvalue.content.details[1].url = resdata[two];
                  // sendingvalue.content.details[two].url = resdata[3];
                }
                sendMeditation();
              } else {
                setLoad(false);
                imageerror();
              }
            }
            sendMusic();
          }
          else {
            sendMeditation();
          }
        }
       }>
        {({ values, handleChange, isSubmitting = true, validateForm, errors, touched,setFieldError }) => (
            <Form>
             <div className={classes.main}>
              <div className={classes.holder}>
                <GridContainer>
                 <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                   <Fieldtext name={"title"} label="Title *" disabled={false}/>
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Resourceid setFieldErrors={setFieldError} disabled={handleDisable}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Fieldtext name={"veevacontentid"} label="Veeva Content ID*" disabled={true}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Category categoryOptions= {selectOptions} />
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name='topicid'
                      options={selectTopic}
                      placeholder="Topic ID *"
                      component={Selectoption}
                      label="Topic ID *"
                      variant="filled"
                      isSearchable={false}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                <Persona personaoptions={personaMedValue}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <DiseaseSegment diseaseSegmentoptions={diseaseSegmentmedValue}/>
                  </GridItem>
                  <GridItem md={12} lg={12} sm={12} xs={12}>
                    <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Content
                      </b>
                    </Typography>
                      </GridItem>
                  <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                      <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        Add Image *
                      </b>
                    </Typography>
                    <Field
                      name={"content[image]"}
                      type="file"
                      component={File}
                      variant="filled"
                      onChange={handleChange}
                      className={classes.inputItem}
                      label="Image *"
                    />
                    <br/>
                    {errors.content&&touched.content&&errors.content.image&&touched.content.image?
                    <p className={classes.errormessage}>{errors.content.image}</p>:""}
                  </GridItem>
                  <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingBottom}>
                    <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        {"Add Music *"}
                      </b>
                    </Typography>
                      <Audiofield name={"content.details[0].url"}  duration={"content.details[0].duration"} editopen={openpopup} handleChange={handleChange}/>
                  </GridItem>
                  <GridItem md={6} lg={6} sm={12} xs={12} className={classes.audiopadding}>
                      <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        {"Add Voice *"}
                      </b>
                    </Typography>
                    <Audiofield name={"content.details[1].url"} duration={"content.details[1].duration"} editopen={openpopup} handleChange={handleChange}/>
                  </GridItem>
                    <GridItem md={6} lg={6} sm={12} xs={12} className={classes.audiopadding}>
                      <Typography className={classes.gridHeader}>
                      <b className={classes.clr_title}>
                        {"Add Voice/Music *"}
                      </b>
                    </Typography>
                  <Audiofield name={"content.details[2].url"} duration={"content.details[2].duration"} editopen={openpopup} handleChange={handleChange}/>
                  </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.audiopadding}>
                    <Fieldtext name={"content.details[0].duration"} label="Music Duration *"  disabled={false}/>
                </GridItem>
                      <GridItem md={4} lg={4} sm={12} xs={12} className={classes.audiopadding}>
                       <Fieldtext name={"content.details[1].duration"} label="Voice  Duration *" disabled={false}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.audiopadding}>
                    <Fieldtext name={"content.details[2].duration"} label="Voice/Music Duration *" disabled={false}/>
                </GridItem>
                </GridContainer>
              </div>
              </div>
                <Paper style={{ marginTop: "40px", width: "100%",boxShadow:"none",padding:"15px"}}>
                <Grid container style={{paddingBottom:'5px'}}>
                  <Grid item lg={12} md={12} sm={12} xs={12} style={{ width: '100%'}}>
                    <Button className={classes.createUser}style={{float:"right"}} disabled={disablemedsubmit}
                    onClick={() => validateForm().then(arg => { console.log(arg); })} type="submit" >
                    {load && <CircularProgress color="primary" style={{position: "absolute",right: "40%",top:"-140%"}} />} {"SUBMIT"} </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Form>
          )}
      </Formik>
      {sucessCurr?props.location.state?<SuccessDialog successButton={InactivateTriviaButton} HeaderText={"Success"} BodyText={UpdatedMessage} dismiss={handleCloseDialogMed}/>
      :<SuccessDialog successButton={InactivateTriviaButton} HeaderText={"Success"} BodyText={SuccessMessage} dismiss={handleCloseDialogMed}/>:""}
        {errorCurr?<ErrorDialog successButton={InactivateTriviaButton1}  HeaderText={errorMessage1}  dismiss={handleErrorUserMed}/>:""}
        {ImageErrorclosemed?<ErrorDialog successButton={InactivateTriviaButton1}  HeaderText={imageerrormessage}  dismiss={handleErrorUserMed}/>:""}
    </>
   );
  };
export default (withStyles()(AuthenticatedPage()(Meditationform)));